import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

const useIsPageLoaded = () => {
  const queryClient = useQueryClient();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Interval to occasionally check if all queries are idle
    const interval = setInterval(() => {
      const queries = queryClient.getQueryCache().getAll();
      const queriesAreLoaded = queries.every(
        query => query.state.fetchStatus === "idle"
      );
      setIsLoaded(queriesAreLoaded);
    }, 1000);

    return () => clearInterval(interval);
  }, [queryClient]);

  return isLoaded;
};

export default useIsPageLoaded;
